/* eslint-disable @typescript-eslint/naming-convention */
import React from 'react';
import snakeToCapitalize from '@utils/functions/snakeToCapitalize';
import { VersionEvent } from '../../../types';
// Map of keys to their display names
const FLAG_DISPLAY_NAMES = {
    has_joint_commission: 'Joint Commission',
    has_dnv_reporting: 'DNV Reporting'
};
export default function flagDetailStrategy() {
    return {
        appliesTo: (key) => Object.keys(FLAG_DISPLAY_NAMES).includes(key),
        render: (key, newValue, oldValue, versionEvent) => {
            const displayName = FLAG_DISPLAY_NAMES[key] || snakeToCapitalize(key);
            const isEnabled = Boolean(newValue);
            // For Create events, just show the flag status
            if (versionEvent === VersionEvent.Create) {
                return (React.createElement("span", { key: key },
                    displayName,
                    ": ",
                    React.createElement("b", null, isEnabled ? 'Enabled' : 'Disabled')));
            }
            // For Update events, show what happened
            const wasEnabled = Boolean(oldValue);
            if (wasEnabled === isEnabled) {
                return (React.createElement("span", { key: key },
                    displayName,
                    " remains ",
                    isEnabled ? 'enabled' : 'disabled'));
            }
            return (React.createElement("span", { key: key },
                displayName,
                " was ",
                isEnabled ? 'enabled' : 'disabled'));
        }
    };
}
